import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 全局状态
  },
  getters: {
    // 计算属性
  },
  mutations: {
    // 同步修改状态
  },
  actions: {
    // 异步操作
  },
  modules: {
    // 模块化状态管理
  }
})